import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import Group from './group'

const Layouts = function ({
  formControl,
  content,
  data,
  fields,
  editableFields,
  useScrollIntoView,
  activeNavIndex,
  className,
  widgets,
  waterMarkDefs,
  detailData,
  isHiddenMedia,
  refConditonFields,
}) {
  const [showData, setShowData] = useState(data && data.then ? null : data)

  useEffect(() => {
    if (data && data.then) {
      data.then((v) => {
        setShowData(v)
      })
    } else {
      setShowData(data)
    }
  }, [data])

  const { targetRef } = useScrollIntoView
  const props = {}
  if (activeNavIndex === content.index && targetRef) {
    props.ref = targetRef
  }

  return (
    <div {...props} className={clsx([className, 'w-full relative'])}>
      {content.title && (
        <div
          className="w-full flex items-center px-4"
          style={{ background: '#F3F3F3', height: '44px', fontSize: '16px' }}
        >
          <b>{content.title}</b>
        </div>
      )}
      {content.type === 'group' && (
        <Group
          useScrollIntoView={useScrollIntoView}
          content={content}
          fields={fields}
          editableFields={editableFields}
          data={showData}
          formControl={formControl}
          widgets={widgets}
          detailData={detailData}
          waterMarkDefs={waterMarkDefs}
          isHiddenMedia={isHiddenMedia}
        />
      )}
      {content.type === 'groups' && (
        <div className="flex flex-col">
          {content.children.map((child, index) => {
            return (
              <Group
                key={`content-children-${index}`}
                content={child}
                isActive={activeNavIndex === child.index}
                fields={fields}
                editableFields={editableFields}
                data={showData}
                formControl={formControl}
                useScrollIntoView={useScrollIntoView}
                widgets={widgets}
                detailData={detailData}
                isHiddenMedia={isHiddenMedia}
                waterMarkDefs={waterMarkDefs}
                refConditonFields={refConditonFields}
              />
            )
          })}
        </div>
      )}
    </div>
  )
}

export default Layouts
